import { createFileRoute } from '@tanstack/react-router'

import { loadByBrokerRedirect } from '@/screens/brokers/ByBrokerRedirect.loader'

/**
 * `/brokers/by-broker` — the sidebar's "Broker's Choice" row with no house in
 * view. See `ByStockRedirect.tsx` for why `component` never renders on a
 * real visit.
 */
export const Route = createFileRoute('/_app/brokers/by-broker')({
  loader: loadByBrokerRedirect,
  component: () => null,
})
